import React from "react";
import "./boqHeader.css";
import { getCurrentDate } from "../RoofSelection/roofFunction";
import { useSelector } from "react-redux";


export default function BOQHeader() {
  const roofInfo = useSelector((state) => state.roof)
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData[roofIndex];

  return (
    <div className="boqHeaderContainer">
      <div className="boqHead">
        <img src="../images/Logos/pvxLogo.svg" alt="logo" />
        <span className="boqLine"></span>
      </div>
      <div className="boqSubDetails">
        <div className="subDetails">
          <h3>Date</h3>
          <h4>{getCurrentDate()}</h4>
        </div>
        <div className="subDetails">
          <h3>Project Name</h3>
          <h4>{roofInfo.value.siteName}</h4>
        </div>
        <div className="subDetails">
          <h3>Roof Type</h3>
          {quantityInfo.allRoof ? <h4>Multiple Roof</h4>: <h4>{roofDetail.roofType}</h4>}
        </div>
      </div>
      <div className="infoHeader">
        <h5>BILL OF QUANTITY</h5>
      </div>
    </div>
  );
}
